import Bugsnag from "@bugsnag/js";

export function recordError(errorMessage: string, diagnosticsData?: { [key: string]: any }) {
    console.error(errorMessage, { ...diagnosticsData });
    Bugsnag.notify(errorMessage, event => event.addMetadata("diagnostics", { ...diagnosticsData }));
}
